import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BuildingMapDto } from '../../../../models/building-map.model';

enum HeaderButton {
  Details,
  Sphere
}

@Component({
  selector: 'app-bc-map-full-details',
  templateUrl: './bc-map-full-details.component.html',
  styleUrls: ['./bc-map-full-details.component.scss'],
  standalone: false
})
export class BcMapFullDetailsComponent implements OnInit {
  @Input() building: BuildingMapDto;
  @Output() closeClicked = new EventEmitter<void>()

  coordinatesCopied = false;
  slrnCopied = false;

  activeButton: HeaderButton = HeaderButton.Details;
  HeaderButton = HeaderButton;
  showStreetView: boolean = false;

  @ViewChild('streetViewContainer', { static: false }) streetViewContainer!: ElementRef;
  streetViewPanorama?: google.maps.StreetViewPanorama;

  ngOnInit(): void {
  }

  showMore() {
    var url = `/buildings/edit/${this.building.id}`;
    window.open(url, '_blank');
  }

  copyCoordinates(): void {
    const coordinates = `${this.building.latitude}, ${this.building.longitude}`;
    navigator.clipboard.writeText(coordinates).then(() => {
      this.coordinatesCopied = true;
      setTimeout(() => {
        this.coordinatesCopied = false;
      }, 1500);
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }

  copySlrn(): void {
    const slrn = `${this.building.slrn}`;
    navigator.clipboard.writeText(slrn).then (() => {
      this.slrnCopied = true;
      setTimeout(() => {
        this.slrnCopied = false;
      }, 1500);
    }).catch(err => {
      console.error('Could not copy text', err);
    })
  }

  openBuildingDetails() {
    var url = `/buildings/edit/${this.building.id}`;
    window.open(url, '_blank');
  }

  openCustomerDetailsPage(id: number) {
    var url = `/customers/edit/${id}`;
    window.open(url, '_blank');
  }

  changeActiveButton(btn: HeaderButton) {
    this.activeButton = btn;
    if (btn == HeaderButton.Sphere) {
      this.checkAndInitStreetView(this.building.latitude!, this.building.longitude!);
    }
  }

  checkAndInitStreetView(lat: number, lng: number): void {
    const streetViewService = new google.maps.StreetViewService();
    const latLng = new google.maps.LatLng(lat, lng);

    streetViewService.getPanorama(
      { location: latLng, radius: 50 },
      (data, status) => {
        if (status === google.maps.StreetViewStatus.OK) {
          this.initStreetView(lat, lng);
        } else {
          this.showStreetView = false;
        }
      }
    );
  }

  initStreetView(lat: number, lng: number) {
    if (!this.streetViewContainer) return;

    this.showStreetView = true;
    this.streetViewPanorama = new google.maps.StreetViewPanorama(
      this.streetViewContainer.nativeElement,
      {
        position: { lat: lat, lng: lng },
        pov: {
          heading: 34,
          pitch: 10,
        },
        zoom: 1,
      }
    );
  }

  closeModal() {
    this.closeClicked.emit();
  }

}